import { useState, useEffect } from 'react';
import { Mail, MessageSquare, CheckCircle2, XCircle } from 'lucide-react';
import { api } from '@/lib/api';

export default function AdminSettings() {
  const [channels, setChannels] = useState(null);

  useEffect(() => {
    api.get('/admin/settings/notification-channels').then((r) => setChannels(r.data)).catch(() => {});
  }, []);

  if (!channels) return null;

  return (
    <div data-testid="admin-settings">
      <p className="font-manrope text-dark/60 mb-6">Notification channels used for customer and admin emails/texts.</p>
      <div className="grid sm:grid-cols-2 gap-6 max-w-2xl">
        <div className="bg-white rounded-2xl border border-forest/10 p-6" data-testid="channel-email">
          <div className="flex items-center gap-3 mb-2">
            <Mail className="w-5 h-5 text-forest" />
            <h3 className="font-playfair text-lg font-bold text-dark">Email</h3>
          </div>
          <p className="font-manrope text-sm text-dark/60 mb-3">Provider: {channels.email.provider} &middot; Sending from {channels.email.sender}</p>
          <span className="flex items-center gap-1.5 text-sm font-manrope font-bold text-forest"><CheckCircle2 className="w-4 h-4" />Active</span>
        </div>
        <div className="bg-white rounded-2xl border border-forest/10 p-6" data-testid="channel-sms">
          <div className="flex items-center gap-3 mb-2">
            <MessageSquare className="w-5 h-5 text-forest" />
            <h3 className="font-playfair text-lg font-bold text-dark">SMS</h3>
          </div>
          <p className="font-manrope text-sm text-dark/60 mb-3">Provider: {channels.sms.provider}</p>
          {channels.sms.configured ? (
            <span className="flex items-center gap-1.5 text-sm font-manrope font-bold text-forest"><CheckCircle2 className="w-4 h-4" />Active</span>
          ) : (
            <>
              <span className="flex items-center gap-1.5 text-sm font-manrope font-bold text-dark/40 mb-2"><XCircle className="w-4 h-4" />Not configured</span>
              <p className="text-xs font-manrope text-dark/40">Add TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN, and TWILIO_PHONE_NUMBER to the backend environment to turn on SMS reminders automatically &mdash; no code changes needed.</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
